<template>
    <div>
        <a href="javascript:void(0)" v-if="!isAdded" @click="addProduct()" class="add-to-project">
            <i class="demo-icon icon-plus-circled orange-add"></i>{{productName}}
        </a>
        <a href="javascript:void(0)" v-else class="add-to-project">
            <i class="demo-icon icon-plus-circled"></i>{{productName}}
        </a>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * Компонент для добавления товаров в список проекта
     *
     * Для работы необходимо передать Id товара и Id проекта
     *
     *  - product_id id товара
     *  - product_name название товара
     *  - project_id id проекта в который нужно добавить товар
     * @vuedoc
     * @module vue:components/AddToProject
     * @exports vue:components/AddToProject
     */
    export default {
        name: "add-to-project",

        components: {},

        props: [
            'product_id', 'product_name', 'project_id',
        ],

        data() {
            return {
                productId: this.product_id,
                productName: this.product_name,
                projectId: this.project_id,
            }
        },

        computed: {
            ...mapGetters('productQuantity', ['productQuantity']),
            ...mapGetters('project', ['projectItems']),

            isAdded() {
                var added = false;
                for (var val in this.projectItems) {
                    if (val == this.product_id) {
                        added = true;
                    }
                }
                return added;
            }

        },

        mounted() {
        },

        methods: {

            /**
             *  Метод добавляет товар в проект пользователя
             *
             * @method getProjectItems
             */
            addProduct() {

                var quantity;
                if (!this.project_id) {
                    console.log("no project id");
                } else {
                    if (this.productQuantity[this.product_id])
                        quantity = this.productQuantity[this.product_id];
                    else
                        quantity = 1;
                    this.$store.dispatch('project/addProduct', {
                        productId: this.product_id,
                        projectId: this.project_id,
                        quantity: quantity
                    });
                }
            },
        }
    }
</script>
